import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://3c6790e252a54e779a8c66c481dc2b5d@o452987.ingest.sentry.io/5795435",
  enabled: process.env.NODE_ENV === "production",
  integrations: [new Integrations.BrowserTracing()],
  environment: "production",
  release: process.env.REVISION,
  tracesSampleRate: 1.0,
});
